import first from "./first";
import second from "./second";
import third from "./third";




export default {
    name: 'logistics',
    components: {
        first,
        second,
        third
    }
}